module.exports = __webpack_public_path__ + "static/img/bg-tit2.8b3c99bc.png";